// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html



// AbilityIntranet.Data.Intranet.QbModels.QbAddress
export class QbAddress {
    public addr1: string = null;
    public addr2: string = null;
    public addr3: string = null;
    public addr4: string = null;
    public addr5: string = null;
    public city: string = null;
    public state: string = null;
    public postalCode: string = null;
    public country: string = null;
    public note: string = null;
}


    



